import { useRouter } from "next/router";

const BlogsCategoryBar = ({
  categories,
  onClick,
  resetHandler,
  selected,
  params,
}) => {
  const router = useRouter();
  return (
    <div className="collapse d-xl-block w-100" id="collapsibleBlogCategories">
      <div className="collapsibleBlogCategories d-block d-xl-flex">
        <div
          id="category_0"
          className="d-none d-xl-flex align-items-center active activetopic"
        >
          <div className="topic">TOPICS</div>
        </div>
        <div
          id="category_1"
          className={
            router.pathname === "/blogs" ? `mo-active category` : `category`
          }
          onClick={resetHandler}
        >
          <img
            src={
              params.category && params.subcategory
                ? encodeURI(
                    `https://assets.alanvidyushbaptist.com/icons/${params.subcategory} White.png`
                  )
                : params.category
                ? encodeURI(
                    `https://assets.alanvidyushbaptist.com/icons/${params.category} White.png`
                  )
                : `https://assets.alanvidyushbaptist.com/icons/Blog_White.png`
            }
            alt={"All_Blogs"}
            className={`mt-auto mb-auto category`}
            height="30px"
            width="30px"
          />
          <div>ALL</div>
        </div>
        {categories &&
          categories.map((category, index) => {
            return (
              <div
                id={"category_" + category.name}
                key={index}
                onClick={() => onClick(category.name)}
                className={category.name === selected ? `category` : `category`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapsibleBlogCategories"
                aria-expanded="false"
                aria-controls="collapsibleBlogCategories"
              >
                {category && (
                  <img
                    src={encodeURI(
                      `https://assets.alanvidyushbaptist.com/icons/${category.name} White.png`
                    )}
                    alt={category.name + "_icon"}
                    className="mt-auto mb-auto"
                    height="30px"
                    width="30px"
                  />
                )}
                <div className="m-xl-auto">{category.name}</div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default BlogsCategoryBar;
